import React from "react";
import { ShieldCheck, CheckCircle2 } from "lucide-react";
import { INSURERS } from "@/data/insurers";

/**
 * InsurersStrip — trust cue that the clinic accepts cashless treatment
 * from 30+ insurers and TPAs. Used on Home, Contact, and Cataract service pages.
 */
export default function InsurersStrip({ compact = false, className = "" }) {
  return (
    <section
      className={`bg-secondary/40 border-y border-border ${className}`}
      data-testid="insurers-strip"
    >
      <div className="container-wide py-14 sm:py-16">
        <div className="grid lg:grid-cols-12 gap-8 items-start">
          <div className="lg:col-span-4">
            <div className="inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/5 px-3.5 py-1.5 text-[11px] uppercase tracking-[0.2em] text-primary mb-4">
              <ShieldCheck className="h-3.5 w-3.5" />
              Cashless Facility
            </div>
            <h2 className="font-serif text-3xl sm:text-4xl text-foreground leading-tight">
              {INSURERS.length}+ insurers &amp; TPAs accepted.
            </h2>
            <p className="mt-4 text-foreground/70 leading-7 text-sm sm:text-base">
              We accept cashless treatment from most major Indian insurers and
              health TPAs — including for cataract surgery, oculoplasty and
              day-care procedures. Our team helps you with the paperwork end to
              end.
            </p>
            {!compact && (
              <ul className="mt-6 space-y-2.5 text-sm text-foreground/80">
                {[
                  "End-to-end cashless authorisation support",
                  "Pre-authorisation reminders and reimbursement help",
                  "Documentation prepared by our in-house TPA desk",
                ].map((line) => (
                  <li key={line} className="flex items-start gap-2">
                    <CheckCircle2 className="h-4 w-4 text-primary mt-0.5 shrink-0" />
                    <span>{line}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="lg:col-span-8">
            <ul
              className="flex flex-wrap gap-2 sm:gap-2.5"
              data-testid="insurers-list"
            >
              {INSURERS.map((name) => (
                <li
                  key={name}
                  className="inline-flex items-center rounded-full border border-border bg-card px-3.5 py-1.5 text-xs sm:text-[13px] text-foreground/80 hover:border-primary/40 hover:text-foreground transition-colors"
                  data-testid={`insurer-${name.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
                >
                  {name}
                </li>
              ))}
            </ul>
            <p className="mt-5 text-[11px] text-muted-foreground">
              List updated {new Date().toLocaleDateString("en-IN", { month: "long", year: "numeric" })}.
              Coverage varies by policy — please confirm your plan details when booking.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
